// :cow: Cosmose CONFIDENTIAL :iso:
import { Pipe, PipeTransform } from '@angular/core';
import { Series } from '@coa/app/shared/stores-shared/models/series';
import { ChartData } from '@coa/app/shared/simple-line-chart/components/model/chart-data';

@Pipe({
  name: 'labelValue',
})
export class LabelValuePipe implements PipeTransform {

  transform(series: Series[]): ChartData[] {
    return series.map((element) => ({label: element.key, value: element.value}));
  }
}
